import React from 'react';

const headerClass = (value: boolean) =>
  value
    ? 'col-12 pt10 pb10 relative bg-color-cyber'
    : 'col-12 pt10 pb10 relative bg-green';

const aClass = (mark: string) =>
  `${mark} btn white btn--hover-green feria-call-to-action`;

interface ICrossingProduct {
  name: string;
  regularImage: string;
  promoImage: string;
  mark: string;
  url: string;
  promo: boolean;
}

export default function CrossingProduct(props: ICrossingProduct) {
  const { name, regularImage, promoImage, mark, url, promo } = props;

  return (
    <div className="col-12 col-sm-6 col-md-4 mb20">
      <div className="w-100">
        <article className="col-12 br15 o-hidden shadow">
          <div className="row">
            <header className={headerClass(promo)}>
              <h4 className="mb0 text-white sf text-light line-height-140p">
                Seguro
                <br />
                <span className="text-bold">{name}</span>
              </h4>
              {promo && (
                <img
                  className="logo-cyber-feria"
                  src="//sfestaticos.blob.core.windows.net/guideline/cyber/2019/mayo/ico-cyber.svg"
                  alt="Logo Cyber"
                />
              )}
            </header>
            <figure className="w-100 mb0">
              {!promo && (
                <img
                  className="img-fluid w-100"
                  src={regularImage}
                  alt="Seguro"
                />
              )}
              {promo && (
                <img
                  className="img-fluid w-100"
                  src={promoImage}
                  alt="Seguro"
                />
              )}
            </figure>
            <footer className="w-100 text-center bg-white pt15 pb15">
              <a className={aClass(mark)} href={url}>
                Contratar
              </a>
            </footer>
          </div>
        </article>
      </div>
    </div>
  );
}
